module.exports = __webpack_public_path__ + "sw.80f6d573.worker.js";